import { render, staticRenderFns } from "./MariaResultsHeader.vue?vue&type=template&id=24a53a9c&scoped=true"
import script from "./MariaResultsHeader.vue?vue&type=script&lang=js"
export * from "./MariaResultsHeader.vue?vue&type=script&lang=js"
import style0 from "./MariaResultsHeader.vue?vue&type=style&index=0&id=24a53a9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a53a9c",
  null
  
)

export default component.exports